// extracted by mini-css-extract-plugin
module.exports = {"forrests":"style-module--forrests--MHo6U"};